var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsufficientResistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2972 19H34.4596L27.8917 24.5549H33.2631L27.8917 37.6409L36.1349 24.5549H33.2631L35.5499 19H42.7294C43.159 18.9996 43.5844 19.0844 43.9814 19.2493C44.3784 19.4143 44.7391 19.6562 45.0428 19.9613C45.3466 20.2664 45.5875 20.6287 45.7517 21.0274C45.916 21.4261 46.0003 21.8534 46 22.2849V42.7151C46.0003 43.1466 45.916 43.5739 45.7517 43.9726C45.5875 44.3713 45.3466 44.7336 45.0428 45.0387C44.7391 45.3438 44.3784 45.5857 43.9814 45.7506C43.5844 45.9156 43.159 46.0003 42.7294 46H21.2707C20.841 46.0003 20.4156 45.9156 20.0186 45.7506C19.6216 45.5857 19.261 45.3438 18.9572 45.0387C18.6534 44.7336 18.4125 44.3713 18.2483 43.9726C18.084 43.5739 17.9997 43.1466 18 42.7151V22.2849C17.9997 21.8534 18.084 21.4261 18.2483 21.0274C18.4125 20.6287 18.6534 20.2664 18.9572 19.9613C19.261 19.6562 19.6216 19.4143 20.0186 19.2493C20.4156 19.0844 20.841 18.9996 21.2707 19H21.2972Z",
    fill: "#123660"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4.00213C16.5347 4.00213 3.99978 16.5384 3.99978 32C3.99978 47.4616 16.5347 59.9979 32 59.9979C47.4653 59.9979 60.0002 47.4616 60.0002 32C60.0002 16.5384 47.4653 4.00213 32 4.00213ZM0 32C0 14.3257 14.3281 0 32 0C49.6719 0 64 14.3257 64 32C64 49.6743 49.6719 64 32 64C14.3281 64 0 49.6743 0 32Z",
    fill: "#FF0033"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1586 56L8 11.8117L10.8414 9L55 53.1883L52.1586 56Z",
    fill: "#FF0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsufficientResistance);
export default __webpack_public_path__ + "static/media/icon-insufficient-resistance.cec18bd26af22945bcb6fef1a0ad4cb7.svg";
export { ForwardRef as ReactComponent };